'use strict';

var React = require('react');

var SvgMetafieldsMinor = function SvgMetafieldsMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 6v1.5h-.5a1 1 0 0 0-1 1v6a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5v-6a1 1 0 0 0-1-1h-.5v-1.5a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v1.5h-2v-1.5a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1zm1.5.5v1h2v-1h-2zm7 1h2v-1h-2v1zm-8.5 1.5v4.5h12v-4.5h-12z"
  }));
};
SvgMetafieldsMinor.displayName = "MetafieldsMinor";

exports.SvgMetafieldsMinor = SvgMetafieldsMinor;
